import { useRef, useEffect } from 'react'

function DocumentTitle(title) {

  useEffect(() => {
    document.title = title + " | Invitd";
  }, [title]);
}
export default DocumentTitle